function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "LeaveSite",
  className: "all",
  transform: "translate(1.061 1.5)",
  fill: "none",
  stroke: "#002d56",
  strokeMiterlimit: 10,
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M1196.777 135.649h10.544v10.544",
  transform: "translate(-1195.187 -135.649)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_144",
  "data-name": "Line 144",
  transform: "translate(0 1.066)",
  d: "M11.069 0L0 11.069"
}));

function SvgLeaveLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.695,
    height: 14.695,
    viewBox: "0 0 14.695 14.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveLink);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC42OTUiIGhlaWdodD0iMTQuNjk1IiB2aWV3Qm94PSIwIDAgMTQuNjk1IDE0LjY5NSI+CiAgPGcgaWQ9IkxlYXZlU2l0ZSIgY2xhc3M9ImFsbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wNjEgMS41KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xODEiIGRhdGEtbmFtZT0iUGF0aCAxODEiIGQ9Ik0xMTk2Ljc3NywxMzUuNjQ5aDEwLjU0NHYxMC41NDQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTk1LjE4NyAtMTM1LjY0OSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMmQ1NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzE0NCIgZGF0YS1uYW1lPSJMaW5lIDE0NCIgeDE9IjExLjA2OSIgeTI9IjExLjA2OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxLjA2NikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMmQ1NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };